import React from 'react';
import PropTypes from 'prop-types';
import TimeZoneSection from 'components/forms/profile-form/TimeZoneSection';
import { selectWeatherTimeZones } from 'state/selectors/signUpSelectors';
import { connect } from 'react-redux';
import { I18N } from 'commons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import v from 'scss/v';
import AmPmSection from './AmPmSection';
import TimeSection from './TimeSection';

const WheatherTimeSelect = ({
  wheatherChecked,
  handleConfirmWindowShow,
  startTime,
  startMeridiem,
  endTime,
  endMeridiem,
  timeZoneId,
  handleWheatherTimeChange,
  weatherTimeZones,
}) => (
  <div className="gray-box col-md-6">
    <I18N tag="h4" id="nodisturbTitle">
      subscription.nodisturb.title
    </I18N>
    {
      !wheatherChecked &&
      <div className="alert alert-info">
        <FontAwesomeIcon icon={faInfoCircle} color={v('$blue-7')} width="1em" height="1em" />
        <div className="ml-2">
          <b><I18N>home.alert.box.title.info</I18N></b>
          <p className="mb-0"><I18N>ssp.subscription.weather.setting.message1</I18N></p>
        </div>
      </div>
    }

    <div className="form-check mb-2">
      <input
        id="weatherSettingCheck"
        type="checkbox"
        value=""
        checked={wheatherChecked}
        onChange={event => {
          if (!event.target.checked) {
            handleConfirmWindowShow(true);
          } else {
            handleWheatherTimeChange({
              wheatherChecked: true
            });
          }
        }}
      />
      <label className="form-check-label" htmlFor="weatherSettingCheck">
        <I18N>ssp.subscription.weather.setting.checkbox.label</I18N>:
      </label>
    </div>
    <div className="form-group form-inline">
      <div className="form-inline">
        {startTime &&
          <TimeSection
            onChange={event => {
              const { value } = event.target;
              handleWheatherTimeChange({
                startTime: value
              });
            }}
            time={startTime}
            name="startTime"
            title="startTime"
            ariaLabel="startTime"
            disabled={!wheatherChecked}
          />
        }
        {startMeridiem &&
          <AmPmSection
            onChange={event => {
              const { value } = event.target;
              handleWheatherTimeChange({
                startMeridiem: value
              });
            }}
            amPm={startMeridiem}
            name="startMeridiem"
            title="startMeridiem"
            ariaLabel="startMeridiem"
            disabled={!wheatherChecked}
          />
        }
      </div>
      <div className="form-group">
        <I18N>eventSubscription.signUp.message.and</I18N>
      </div>
      <div className="form-inline">
        {
          endTime &&
          <TimeSection
            onChange={event => {
              const { value } = event.target;
              handleWheatherTimeChange({
                endTime: value
              });
            }}
            time={endTime}
            name="endTime"
            title="endTime"
            ariaLabel="endTime"
            disabled={!wheatherChecked}
          />
        }

        {endMeridiem &&
          <AmPmSection
            onChange={event => {
              const { value } = event.target;
              handleWheatherTimeChange({
                endMeridiem: value
              });
            }}
            amPm={endMeridiem}
            name="endMeridiem"
            title="endMeridiem"
            ariaLabel="endMeridiem"
            disabled={!wheatherChecked}
          />
        }
      </div>
    </div>
    {
      timeZoneId !== undefined &&
        <TimeZoneSection
          disabled={!wheatherChecked}
          onChange={event => {
            const { value } = event.target;
            handleWheatherTimeChange({
              timeZoneId: value
            });
          }}
          timeZone={timeZoneId}
          timeZones={weatherTimeZones}
        />
    }
    <I18N tag="span">ssp.subscription.weather.setting.noteText</I18N>
  </div>
);

WheatherTimeSelect.propTypes = {
  wheatherChecked: PropTypes.bool.isRequired,
  handleConfirmWindowShow: PropTypes.func.isRequired,
  startTime: PropTypes.string.isRequired,
  startMeridiem: PropTypes.string.isRequired,
  endTime: PropTypes.string.isRequired,
  endMeridiem: PropTypes.string.isRequired,
  timeZoneId: PropTypes.string.isRequired,
  handleWheatherTimeChange: PropTypes.func.isRequired,
  weatherTimeZones: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

const mapStateToProps = state => ({
  weatherTimeZones: selectWeatherTimeZones(state),
});

export default connect(
  mapStateToProps,
)(WheatherTimeSelect);
